import React from "react";
import { FiSmartphone } from "react-icons/fi";

interface LoginCredentialsFormProps {
  mobileNumber: string;
  setMobileNumber: (val: string) => void;
  password: string;
  setPassword: (val: string) => void;
  showPassword: boolean;
  setShowPassword: (val: boolean) => void;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  error?: string | null;
}

const LoginCredentialsForm: React.FC<LoginCredentialsFormProps> = ({
  mobileNumber,
  setMobileNumber,
  // password,
  // setPassword,
  // showPassword,
  // setShowPassword,
  onSubmit,
  loading,
  error,
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-5 mt-8 max-w-sm mx-auto w-full">
      <div className="space-y-1.5">
        <label
          htmlFor="mobileNumber"
          className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase"
        >
          Mobile Number
        </label>
        <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
            <FiSmartphone size={18} />
          </div>
          <input
            id="mobileNumber"
            type="text"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="9999999999"
            className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
          />
        </div>
      </div>

      {/* <div className="space-y-1.5">
        <label
          htmlFor="password"
          className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase"
        >
          Password
        </label>
        <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
            <FiLock size={18} />
          </div>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            className="block w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            autoComplete="off"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-violet-600 transition-colors cursor-pointer focus:outline-none"
            tabIndex={-1}
          >
            {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
          </button>
        </div>
      </div> */}

      {error && (
        <div className="mt-4 bg-red-50/50 border border-red-100 text-red-600 px-4 py-3 rounded-xl shadow-sm text-xs font-medium backdrop-blur-sm animate-pulse-soft">
          <p>{error}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full flex justify-center items-center py-4 px-4 border border-transparent rounded-2xl shadow-lg shadow-violet-500/20 text-sm font-bold text-white bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 focus:outline-none focus:ring-4 focus:ring-violet-500/20 disabled:opacity-50 disabled:cursor-not-allowed transform transition-all active:scale-[0.98] duration-300 hover:shadow-violet-500/30 mt-2"
      >
        {loading ? (
          <span className="flex items-center gap-2">
            <svg
              className="animate-spin h-5 w-5 text-white/90"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span className="tracking-wide">Authenticating...</span>
          </span>
        ) : (
          "Get OTP"
        )}
      </button>
    </form>
  );
};

export default LoginCredentialsForm;
